<template>
  <el-select
    v-model="vendorId"
    filterable
    remote
    clearable
    :placeholder="placeholder"
    :remote-method="remoteMethod"
    :loading="loading"
    @change="handleChange">
    <el-option
      v-for="item in options"
      :key="item.vendorId"
      :label="item.vendorName"
      :value="item.vendorId">
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'EntAutoSelect',
  components: {},
  props: {
    value: {
      // type: [Number, null],
      required: true
    },
    placeholder: {
      type: String,
      default: '请输入企业名称'
    },
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      options: []
    }
  },
  computed: {
    vendorId: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    handleChange() {
      this.callback && this.callback()
    },
    remoteMethod(query) {
      if (query) {
        this.loading = true
        this.$store.dispatch('account/getvendors', {
          payload: {
            pageNum: 1,
            pageSize: 10000,
            vendorName: query
          },
          success: (res) => {
            this.loading = false
            this.options = res.data.records
          },
          fail: () => {
            this.loading = false
            this.options = []
          }
        })
      } else {
        this.options = []
      }
    }
  }
}
</script>
<style lang="stylus" scoped></style>
